<template>
  <FlexColumn :space="0">
    <TextButton :outlined="outlined" :primary="primary" :small="small" :text="text" :disabled="disabled" depressed @click="handleOpenDetail">
      <v-icon v-if="icon" class="mr-1">{{icon}}</v-icon>
      <Label :size="labelSize" :text="label" />
    </TextButton>
    <ApplicantDetailDialog
        v-if="useDialog"
        :open="open"
        :targetJob="targetJob"
        :applicant="details"
        :showActions="showActions"
        :requestorId="requestorId"
        @close="handleCloseDetail"
    />
    <ApplicantDetailPanel
        v-else
        :open="open"
        :applicant="details"
        :targetJob="targetJob"
        :requestorId="requestorId"
        :outlined="outlined"
        @close="handleCloseDetail"
    />
  </FlexColumn>
</template>

<script>
import TextButton from "@/components/atoms/TextButton";
import FlexColumn from "@/components/atoms/FlexColumn";
import ApplicantDetailDialog from "@/components/organisms/ApplicantDetailDialog";
import ApiMixin from "../../ApiMixin";
import {convertApplicant} from "../../stores/chat_requests";
import Label from "../atoms/Label"
import ApplicantDetailPanel from "../organisms/ApplicantDetailPanel";

export default {
  name: "ApplicantDetailsButton",
  components: {ApplicantDetailPanel, ApplicantDetailDialog, FlexColumn, TextButton, Label},
  mixins: [ApiMixin],
  props: {
    applicant: {
      type: Object
    },
    userId: {
      type: String
    },
    targetJob: {
      type: Object
    },
    label: {
      type: String,
      default: "詳細を見る"
    },
    labelSize: {
      type: String,
      default: undefined,
    },
    outlined: {
      type: Boolean,
      default: true
    },
    primary: {
      type: Boolean,
      default: false
    },
    showActions: {
      type: Boolean,
      default: false
    },
    anonymousId: {
      type: [String, Number],
      default: undefined
    },
    requestorId: {
      type: String
    },
    useDialog: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String
    },
    small: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      open: false,
      userDetails: undefined
    }
  },
  computed: {
    details() {
      return this.applicant || this.userDetails
    },
  },
  methods: {
    async handleOpenDetail() {
      if (this.userId) {
        const clientUser = await this.loadClientUser(this.userId)
        const request = clientUser.requests.find(request => request.jobId === this.targetJob.id)
        this.userDetails = convertApplicant({...clientUser, request})
      }
      this.open = true
    },
    handleCloseDetail() {
      this.open = false
    }
  },
}
</script>

<style scoped>

</style>
